import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { SampleSearchPipe } from '../../../../core/pipes/sample-search.pipe';
import { LoadingComponent } from '../../../components/loading/loading.component';
import { HeaderComponent } from '../../../admin/layout/includes/header/header.component';
import { TaskListStudentViewComponent } from '../../../components/task-list-student-view/task-list-student-view.component';

@Component({
    selector: 'app-professor-student-task-view',
    templateUrl: './professor-student-task-view.component.html',
    imports: [
        TaskListStudentViewComponent,
        CommonModule, FormsModule, NgbModule, LoadingComponent, SampleSearchPipe, HeaderComponent, NgSelectModule
    ],
    styleUrls: ['./professor-student-task-view.component.css']
})
export class ProfessorStudentTaskViewComponent {
  tag="professors-student-tasklists"
}
